export default "__VITE_ASSET__EJIXMHj2__"